﻿import React from 'react';
import { str_isEmpty } from '@Util/Utils';
import { Textarea_With_Label_Props } from '@Util/Types';

export default function Textarea_With_Label(props: Textarea_With_Label_Props): JSX.Element {

    function generate_element_class(): string {
        let class_str: string = "Form_Row";

        if (!str_isEmpty(props?.className)) {
            class_str += ` ${props.className}`;
        }

        if (props.error) {
            class_str += " Form_Row--Error";
        }

        return class_str;
    }

    return (
        <div className={generate_element_class()}>
            {
                !str_isEmpty(props.label) &&
                <label htmlFor={props.id}>{props.label}</label>
            }
            <textarea
                value={props.value}
                onChange={props.onChange}
                id={props.id}
                name={props.id}
                rows={props.rows}
            />
        </div>
    )
}